// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"67fb6813","450":"9afbce25","453":"bcb4d015","558":"28e62ace"}[chunkId] + ".chunk.js";
};